export enum UserRole {
  User = 'user',
  Admin = 'Centaur.Admin',
  // RL Workflow roles (M003)
  PE = 'Centaur.PE',
  PeSteward = 'Centaur.PESteward',
  WLMEngineer = 'Centaur.WLMEngineer',
  WRO = 'Centaur.WRO',
  TA = 'Centaur.TA',
  Scheduler = 'Centaur.Scheduler',
  WLMWSR = 'Centaur.WLMWSR',
  ALS = 'Centaur.ALS',
  IOC = 'Centaur.IOC',
  Environmental = 'Centaur.Environmental',
  COE = 'Centaur.COE',
  ChemicalRepresentative = 'Centaur.ChemicalRepresentative',
  ChemicalAdvisor = 'Centaur.ChemicalAdvisor',
  FieldOps = 'Centaur.FieldOps',
  FieldOpsSupervisors = 'Centaur.FieldOpsSupervisors',
  // PA/WB Workflow roles (M008)
  Land = 'Centaur.Land',
  LandSupervisor = 'Centaur.LandSupervisor',
  SSPS = 'Centaur.SSPS',
  WLMTeamLead = 'Centaur.WLMTeamLead',
  WLMSuperintendent = 'Centaur.WLMSuperintendent',
  PAEngineer = 'Centaur.PAEngineer',
  FSM = 'Centaur.FSM',
  FSMSupervisor = 'Centaur.FSMSupervisor',
  PACoordinator = 'Centaur.PACoordinator',
  PASuperintendent = 'Centaur.PASuperintendent',
  PAWSR = 'Centaur.PAWSR',
  Reader = 'Centaur.Reader',
  SubSurfaceSupervisor = 'Centaur.SubSurfaceSupervisor',
}
